import RanksPage from '@/modules/rank/ranks-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/ranks/')({
  component: RanksPage,
});
